import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import type { editor as MonacoEditor } from 'monaco-editor';

@Component({
  selector: 'json-diff-viewer',
  templateUrl: './json-diff-viewer.component.html',
  styleUrls: ['./json-diff-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class JsonDiffViewerComponent {
  original = input.required<string>();
  modified = input.required<string>();

  isLoading = computed(
    () => this.original() === undefined || this.modified() === undefined
  );

  options: MonacoEditor.IDiffEditorConstructionOptions = {
    automaticLayout: true,
    readOnly: true,
    renderSideBySide: true,
    originalEditable: false,
    scrollBeyondLastLine: false,
    scrollbar: {
      verticalScrollbarSize: 0,
      horizontalScrollbarSize: 0,
      useShadows: false
    }
  };
}
